export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    }
};

export const typeContainerVariants = {
    // color type
    single: {
        backgroundColor: '#fff',
        border: '2px solid #ccc'
    },
    gradient: {
        backgroundColor: '#edf0f6',
        border: '2px solid #607ca7'
    },
    // gradient type
    linear: {
        backgroundColor: '#fff',
        border: '2px solid #ccc'
    },
    radial: {
        backgroundColor: '#edf0f6',
        border: '2px solid #607ca7'
    },
    // transparency
    off: {
        backgroundColor: '#fff',
        border: '2px solid #ccc'
    },
    on: {
        backgroundColor: '#edf0f6',
        border: '2px solid #607ca7'
    }
};

export const typeVariants = {
    // color type
    single: {
        left: '.2rem',
        backgroundColor: '#bbb',
    },
    gradient: {
        left: '1.45rem',
        backgroundColor: '#607ca7',
    },
    // gradient type
    linear: {
        left: '.2rem',
        backgroundColor: '#bbb'
    },
    radial: {
        left: '1.45rem',
        backgroundColor: '#607ca7'
    },
    // transparency
    off: {
        left: '.2rem',
        backgroundColor: '#bbb'
    },
    on: {
        left: '1.45rem',
        backgroundColor: '#607ca7'
    },
};

export const typeLabelVariants = {
    // color type
    single: {
        color: '#888',
    },
    gradient: {
        color: '#607ca7'
    },
    // gradient type
    linear: {
        color: '#888'
    },
    radial: {
        color: '#607ca7'
    },
    // transparency
    off: {
        color: '#888'
    },
    on: {
        color: '#607ca7'
    }
};

export const disabledVariants = {
    disabled: {
        opacity: .4
    },
    enabled: {
        opacity: 1
    }
};

export const logoVariants = {
    noLogo: {
        backgroundColor: '#fff',
        border: '2px dashed #ddd'
    },
    yesLogo: {
        backgroundColor: '#edf0f6',
        border: '2px solid #607ca7'
    }
}